// "In The Press" entries, newest first. Press.jsx sorts by date anyway, so a
// misplaced entry still lands in the right spot. Entries with the same date
// keep the order they have here (the first one is the featured card).
//
// date     "YYYY-MM-DD" (or "YYYY-MM" when only the month is known)
// outlet   publication name as readers know it
// title    the article's headline
// url      link to the article (omit if there is nothing to link to)
// image    thumbnail under public/images/press/
// summary  optional one-line dek, shown when the entry is the featured (newest) one
// legacy   true for the old page screenshots, which are letterboxed instead of cropped
//
// New thumbnails are generated: see press-thumbs/README.md.
const pressArticles = [
  {
    date: "2026-09-29",
    outlet: "Deadline",
    title:
      "PaperAirplane's Cinemas & Studios Marketing Hub The Hangar Clocks 2 Million-Plus Downloads",
    url: "https://deadline.com/2026/09/paperairplane-the-hangar-1237116343/",
    image: "./images/press/2026-09-deadline-hangar-2m.jpg",
    summary:
      "The Hangar, the digital asset management platform from exhibitor and distributor theatrical marketing corp PaperAirplane, has clocked over 2 million downloads.",
  },
  {
    date: "2026-09-29",
    outlet: "Celluloid Junkie",
    // Their headline spells it "The Hanger"; corrected here.
    title:
      "PaperAirplane Media's The Hangar Surpasses 2 Million Digital Asset Downloads, Cementing Position as Theatrical Industry's Leading Marketing Resource",
    url: "https://celluloidjunkie.com/wire/paperairplane-medias-the-hanger-surpasses-2-million-digital-asset-downloads-cementing-position-as-theatrical-industrys-leading-marketing-resource/",
    image: "./images/press/2026-09-celluloidjunkie-hangar-2m.jpg",
    summary:
      "PaperAirplane Media says The Hangar has surpassed two million downloads of studio-provided marketing assets since launching in October 2020.",
  },
  {
    date: "2026-09-29",
    outlet: "Boxoffice Pro",
    title:
      "PaperAirplane Media's Digital Asset Management Platform The Hangar Surpasses 2 Million Digital Asset Downloads",
    url: "https://www.boxofficepro.com/paperairplane-medias-digital-asset-management-platform-the-hangar-surpasses-2-million-digital-asset-downloads/",
    image: "./images/press/2026-09-boxofficepro-hangar-2m.jpg",
  },
  {
    date: "2026-09-29",
    outlet: "Digital Cinema Report",
    title:
      "PaperAirplane Media's Hangar Platform Surpasses Two Million Movie Studio Marketing Assets Shared",
    url: "https://www.digitalcinemareport.com/paperairplane-medias-hangar-platform-surpasses-two-million-movie-studio-marketing-assets-shared/",
    image: "./images/press/2026-09-digitalcinemareport-hangar-2m.jpg",
  },
  {
    date: "2026-09-29",
    outlet: "Archyde",
    title:
      "PaperAirplane's The Hangar Movie Marketing Hub Surpasses 2 Million Downloads",
    url: "https://www.archyde.com/paperairplanes-the-hangar-movie-marketing-hub-surpasses-2-million-downloads/",
    image: "./images/press/2026-09-archyde-hangar-2m.jpg",
    summary:
      "PaperAirplane's digital asset management platform, The Hangar, has officially surpassed two million downloads.",
  },
  {
    date: "2026-08-05",
    outlet: "Deadline",
    title:
      "PaperAirplane Promotes Amanda Rufener to SVP Exhibitor Marketing & Operations",
    url: "https://deadline.com/2026/08/paperairplane-amanda-rufener-1237024380/",
    image: "./images/press/2026-08-deadline-amanda-svp.jpg",
  },
  {
    date: "2026-08-05",
    outlet: "CNBC",
    title:
      "Hollywood is cranking out billion-dollar movies again. 'Spider-Man' just joined the ranks",
    url: "https://www.cnbc.com/2026/08/05/hollywood-2026-billion-dollar-movies.html",
    image: "./images/press/2026-08-cnbc-billion-dollar.jpg",
  },
  {
    date: "2026-06-21",
    outlet: "The Wall Street Journal",
    title: "Hollywood Is Having Its Best Box Office Since Before the Pandemic",
    url: "https://www.wsj.com/business/media/box-office-summer-2026-890603ff?st=VwNNWH&reflink=desktopwebshare_permalink",
    image: "./images/press/2026-06-wsj-best-box-office.jpg",
  },
  {
    date: "2026-02-04",
    outlet: "Deadline",
    title:
      "PaperAirplane Media Hires Alex Franklin To Lead National Radio & Media Ambassador Division",
    url: "https://deadline.com/2026/02/paperairplane-media-alex-franklin-1236709535/",
    image: "./images/press/2026-02-deadline-alex-franklin.jpg",
  },
  {
    date: "2025-12-18",
    outlet: "Celluloid Junkie",
    title: "CJ's Top Women In Global Distribution 2025",
    url: "https://celluloidjunkie.com/2025/12/18/cjs-top-women-in-global-distribution-2025/#:~:text=Amanda%20Rufener",
    image: "./images/press/2025-12-celluloidjunkie-top-women.jpg",
  },
  {
    date: "2025-10-28",
    outlet: "Celluloid Junkie",
    title:
      "From Grounded to Global: How PaperAirplane is Helping Movie Marketing Reach New Heights",
    url: "https://celluloidjunkie.com/2025/10/28/from-grounded-to-global-how-paperairplane-is-helping-movie-marketing-reach-new-heights/",
    image: "./images/press/2025-10-celluloidjunkie-grounded-to-global.jpg",
  },
  {
    date: "2024-09-25",
    outlet: "Deadline",
    title:
      "Cinema Marketing Firm PaperAirplane Media Achieves Another Milestone; Plans Overseas Expansion",
    url: "https://deadline.com/2024/09/box-office-paperairplane-media-1236099271",
    image: "./images/press/2024-09-deadline-milestone.jpg",
  },
  {
    date: "2023-09-26",
    outlet: "Boxoffice Pro",
    title:
      "Geneva Convention 2023 Innovator of the Year: PaperAirplane Co-Founders Mike Polydoros and Will Preuss",
    url: "https://www.boxofficepro.com/geneva-convention-2023-innovator-of-the-year-paperairplane-co-founders-mike-polydoros-and-will-preuss/",
    image: "./images/press/2023-09-boxofficepro-innovator.jpg",
  },
  {
    date: "2023-07-15",
    outlet: "CNBC",
    title:
      "Where have all the billion-dollar movies gone? So far, only Mario's been super this year",
    url: "https://www.cnbc.com/2023/07/15/billion-dollar-movies-studio-slump.html",
    image: "./images/press/2023-07-cnbc-billion-dollar.jpg",
  },
  {
    date: "2023-07-03",
    outlet: "Deadline",
    title:
      "Cinema Marketing Firm PaperAirplane Hits Milestone With Studios & Exhibitors",
    url: "https://deadline.com/2023/07/box-office-paperairplane-mike-polydoros-will-preuss-1235429455",
    image: "./images/press/2023-07-deadline-500k.jpg",
  },
  {
    date: "2023-05-31",
    outlet: "The New York Times",
    title:
      "Larger Screens, Heated Seats, Sushi: Theater Owners Want You Back",
    url: "https://www.nytimes.com/2023/05/31/business/movie-theater-upgrade-pandemic.html",
    image: "./images/press/2023-05-nytimes-theater-upgrades.jpg",
  },
  {
    // NBCUniversal post quoting Mike from a WSJ piece on Illumination. Month is
    // an estimate (the Super Mario Bros. Movie opened April 2023); no link.
    date: "2023-04",
    outlet: "NBCUniversal",
    title:
      "\"Mario is a home run on every account, and I can't think about an Illumination movie that hasn't worked.\"",
    image: "./images/press/2023-04-nbcuniversal-illumination.jpg",
  },
  {
    date: "2022-07-03",
    outlet: "The Wall Street Journal",
    title: "'Minions: The Rise of Gru' Brings Families Back to Movie Theaters",
    url: "https://www.wsj.com/articles/minions-brings-families-back-to-movie-theaters-11656869821",
    image: "./images/press/2022-07-wsj-minions.jpg",
  },
  {
    date: "2022-01-25",
    outlet: "Deadline",
    title:
      "Cinema Marketing Firm PaperAirplane Helps Exhibition Take Flight During Pandemic",
    url: "https://deadline.com/2022/01/paperairplane-theatrical-marketing-firm-launches-mike-polydoros-will-preuss-lionsgate-vets-1234919406/",
    image: "./images/press/2022-01-deadline-launch.jpg",
  },
];

export default pressArticles;
